import { render, staticRenderFns } from "./OnlineConciergeService.vue?vue&type=template&id=72b2493a&scoped=true"
import script from "./OnlineConciergeService.vue?vue&type=script&lang=js"
export * from "./OnlineConciergeService.vue?vue&type=script&lang=js"
import style0 from "./OnlineConciergeService.vue?vue&type=style&index=0&id=72b2493a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b2493a",
  null
  
)

export default component.exports